<template>
  <html data-wf-page="5b1755d5269b9c68c9d82ca4" data-wf-site="5b1755d5269b9c5142d82ca3">
<head>
  <meta charset="utf-8">
  <title>Cabinet Manager | Sign In</title>
  <meta content="width=device-width, initial-scale=1" name="viewport">
</head>
<body class="body">
  <div class="welcomesec1">
    <div class="brand">
      <SignInButton :user="user" @login="$emit('login')"></SignInButton>
    </div>
    <div class="welcome">
      <div class="div-block-21">
        <div class="welcometext">
          <h1 class="heading">Welcome to Cabinet Manager!</h1>
          <p class="paragraph">Tools for manage cabinet projects, generate work flows and track works automatically.</p>
        </div>
        <div class="links"><a href="/" class="link-block w-inline-block"><img src="../../static/images/home.png" width="24" height="24"><div class="text-block">Home</div></a><a href="/#/users" class="link-block-2 w-inline-block" v-if="userLevel < 2"><img src="../../static/images/members.png" width="24" height="24"><div class="text-block-2">Members</div></a></div>
        <!-- <div class="links"><a href="#" class="link-block w-inline-block"><img src="../../static/images/document-green.png" width="24" height="24"><div class="text-block">Documentation</div></a><a href="#" class="link-block-2 w-inline-block"><img src="../../static/images/support-green.png" width="24" height="24"><div class="text-block-2">Support</div></a></div> -->
      </div>
    </div>
  </div>
  <div class="projectssec">
    <div class="addprojectdiv">
      <a href="#" class="addprojectlink w-inline-block"
        @click="show_add_project_form = true"
      >
        <div class="div-block-11"><img src="../../static/images/add-white.png" height="48" class="image-2">
          <div class="text-block-4">Add Project</div>
        </div>
      </a>
    </div>
    <div class="div-block-22">
      <div class="text-block-13">Recent Projects</div>
    </div>
    <div class="projectsdiv">
      <a :href="'/#/dashboard?project='+ project.id" class="projectlink w-inline-block"
        v-for="project in recent_project"
        v-show="project.status !== 'closed'"
        :key="project.id"
        @click="$emit('set-current-project', project.id)"
      >
        <div class="projectdiv">
          <div class="projectname">{{ project.name }}</div>
          <div class="lastupdatediv">
            <div class="lastupdated">Last Open: </div>
            <div class="datetext">{{ project.last_open_date }}</div>
          </div>
        </div>
      </a>
    </div>
    <div class="div-block-22">
      <div class="text-block-13">Other Projects</div>
    </div>
    <div class="projectsdiv other">
      <a :href="'/#/dashboard?project='+ project.id" class="projectlink w-inline-block"
        v-for="project in other_project"
        v-show="project.status !== 'closed'"
        :key="project.id"
        @click="$emit('set-current-project', project.id)"
      >
        <div class="projectdiv">
          <div class="projectname">{{ project.name }}</div>
          <div class="lastupdatediv">
            <div class="lastupdated">Last Open: </div>
            <div class="datetext">{{ project.last_open_date }}</div>
          </div>
        </div>
      </a>
    </div>
  </div>
  <div class="powereddiv">
    <div class="div-block-14">
      <div class="text-block-9">Powered by </div>
      <a href="http://studioscreation.com" target="_blank" class="poweredlink w-inline-block">
        <div class="text-block-10">Studio S, Inc.</div>
      </a>
    </div>
  </div>
  <AddProjectForm
    :exist_project="exist_project"
    :loading="add_loading"
    v-show="show_add_project_form"
    @close-add-project-form="show_add_project_form = false"
  >
  </AddProjectForm>
</body>
</html>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/webfont/1.4.7/webfont.js" type="text/javascript"></script>
<script type="text/javascript">WebFont.load({  google: {    families: ["Ubuntu:300,300italic,400,400italic,500,500italic,700,700italic","Roboto:100,100italic,300,300italic,regular,italic,500,500italic,700,700italic,900,900italic","Dosis:regular,500,600,700,800"]  }});</script>
<!-- [if lt IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/html5shiv/3.7.3/html5shiv.min.js" type="text/javascript"></script><![endif] -->
<script type="text/javascript">!function(o,c){var n=c.documentElement,t=" w-mod-";n.className+=t+"js",("ontouchstart"in o||o.DocumentTouch&&c instanceof DocumentTouch)&&(n.className+=t+"touch")}(window,document);</script>
<script src="https://code.jquery.com/jquery-3.3.1.min.js" type="text/javascript" integrity="sha256-FgpCb/KJQlLNfOu91ta32o/NMZxltwRo8QtmkMRdAu8=" crossorigin="anonymous"></script>
<script src="../static/js/t2-cabinets-management-system.js" type="text/javascript"></script>
<!-- [if lte IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/placeholders/3.0.2/placeholders.min.js"></script><![endif] -->

<script>
// firestore instance
import { db } from '../main'
import AddProjectForm from './AddProjectForm.vue'
import SignInButton from './SignInButton.vue'

export default {
  name: 'ProjectList',
  data () {
    return {
      project_list: [],
      show_add_project_form: false,
      add_loading: false
    }
  },
  props: ['user','currentProject','userLevel'],
  firestore () {
    return {
      project_list : db.collection('project_list').where('version', '==', 2).orderBy('last_open_date','desc')
    }
  },
  computed: {
    recent_project: function () {
      return this.project_list.slice(0,3)
    },
    other_project: function () {
      return this.project_list.slice(3)
    },
    exist_project: function () {
      let exist_project = [];
      for(var i=0;i<this.project_list.length;i++){
        exist_project.push(this.project_list[i].id)
      }
      return exist_project
    }
  },
  methods: {
    createProject: function (newProject) {
      // console.log('create new project: ' + newProject.name)
      db.collection('project_list').doc(newProject.id).set(newProject).then(() => {
        this.$emit('set-current-project', project.id)
      })
    }
  },
  components: {
    AddProjectForm,
    SignInButton
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProjectList.vue